import routes from '@/routes';

export const DEFAULT_REDIRECT_ROUTE = routes.myDocuments;

export const ROLES = {
	admin: 1,
	extendedCollaborator: 2,
	collaborator: 3
};

export const ERROR_CODES = {
	email_exists: 'email_exists',
	email_invalid: 'email_invalid',
	user_account_closed: 'user_account_closed'
};

export const VIEWS_NAMES = {
	EDITOR: 'editor',
	MY_PDFS: 'myPdfs',
	BILLING: 'billing',
	TAX_INFO: 'taxInfo'
};

export const DEFAULT_COLLABORATOR_VIEWS = [
	VIEWS_NAMES.EDITOR,
	VIEWS_NAMES.MY_PDFS
];

export const DISABLED_VIEWS_FOR_LIMITED = [VIEWS_NAMES.EDITOR];
